'use strict';

angular.module('programme')

.component('articleHero', {
    templateUrl: 'modules/programme/components/articleHero.html',
    bindings: {
        model: '<'
    }
});
